const isPlainObject = value=>{
    return !!value && typeof value === "object" && !Array.isArray(value);
};

const toDetails = details=>{
    if (!isPlainObject(details)) { return {}; }
    return { ...details };
};

const toFields = fields=>{
    if (!Array.isArray(fields)) { return []; }
    return fields.map(field=>String(field || "").trim()).filter(Boolean);
};

export const createValidationError = (code, details)=>({
    code:String(code || "invalid"),
    details:toDetails(details)
});

export const createFieldError = createValidationError;

export const createFormError = (code, fields=[], details)=>({
    ...createValidationError(code, details),
    fields:toFields(fields)
});

export const normalizeValidationError = error=>{
    if (!isPlainObject(error)) { return createValidationError(error); }
    return createValidationError(error.code, error.details);
};

export const normalizeFormError = error=>{
    if (!isPlainObject(error)) { return createFormError(error); }
    return createFormError(error.code, error.fields, error.details);
};

const normalizeFieldErrors = fieldErrors=>{
    if (!isPlainObject(fieldErrors)) { return {}; }
    return Object.fromEntries(Object.entries(fieldErrors).map(([field, error])=>[
        field,
        normalizeValidationError(error)
    ]));
};

const normalizeFormErrors = formErrors=>{
    if (!Array.isArray(formErrors)) { return []; }
    return formErrors.map(normalizeFormError);
};

export class FormError extends Error {
    static is(error) {
        return error instanceof FormError;
    }

    static fromResult(message, result={}, options={}) {
        return new FormError(message, {
            ...options,
            fieldErrors:result.fieldErrors,
            formErrors:result.formErrors
        });
    }

    constructor(message="invalid form", options={}) {
        super(message);
        this.status = options.status || 400;
        this.fieldErrors = normalizeFieldErrors(options.fieldErrors);
        this.formErrors = normalizeFormErrors(options.formErrors);
    }

    get detail() {
        return {
            fieldErrors:this.fieldErrors,
            formErrors:this.formErrors
        };
    }
}
